<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">产品信息</h3>
            <div class="box-tools pull-right" style="display: flex;align-items: center;">
              <add @finish="finish">新增</add>
              <div style="width: 10px;height: 10px;"></div>
              <excel-add @finish="finish">导入</excel-add>
            </div>
          </div>
          <div class="box-body no-padding">
            <div style="padding-top: 20px;padding-left: 20px;">
              <el-form :inline="true">
                <el-form-item label="搜索">
                  <el-input v-model="query.keyword" placeholder="请输入名称或存货编码查询"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="querySelect">查询</el-button>
                  <export>导出</export>
                  <a style="margin-left: 10px;" href="/product.xlsx" target="_blank">
                    <el-button type="text">点击下载导入模板</el-button>
                  </a>
                </el-form-item>
              </el-form>
            </div>

            <el-table :data="list" border v-loading="listLoading" style="width: 100%">
              <el-table-column prop="name" label="产品名称"></el-table-column>
              <el-table-column prop="model_code" label="存货编码"></el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <div style="display: flex;align-items: center;">
                    <edit :id="scope.row.id" @finish="finishNotFirst">编辑</edit>
                    <div style="width: 10px;height: 10px;"></div>
                    <delete :id="scope.row.id" @finish="finishNotFirst">删除</delete>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div style="padding: 10px">
              <el-pagination
                  background
                  layout="total, prev, pager, next"
                  :total="total"
                  :page-size="query.size"
                  :current-page="query.page"
                  @current-change="pageChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import qs from "qs";

import Add from "./Add.vue";
import Edit from "./Edit.vue";
import Delete from "./Delete.vue";
import Export from "./Export.vue";
import ExcelAdd from "./ExcelAdd.vue";

export default {
  components: {
    Add,
    Edit,
    Delete,
    Export,
    ExcelAdd
  },
  data() {
    return {
      params: {},
      query: {
        keyword: '',
        page: 1,
        size: 10,
      },
      list: [],
      total: 0,
      listLoading: false,
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  mounted() {
    const _this = this;
    _this.query = Object.assign(_this.query, _this.$route.query);
    _this.query.page = parseInt(_this.query.page);
    _this.query.size = parseInt(_this.query.size);
    _this.listLoading = true;
    _this.authInit(_this).then(() => {
      _this.loadList();
    });
  },
  methods: {
    ...mapActions(["authInit"]),
    updateUrl() {
      const _this = this;
      const url = _this.$route.path + "?" + qs.stringify(_this.query);
      _this.$router.replace({path: url});
    },
    // 获取列表
    loadList() {
      const _this = this;
      _this.$api.productList(_this.query)
          .then(res => {
            _this.listLoading = false;
            _this.list = res.list;
            _this.total = res.total;
            _this.updateUrl();
          })
          .catch(err => {
            _this.listLoading = false;
            _this.$message.error(err.msg);
          })
    },
    // 分页
    pageChange(page) {
      const _this = this;
      _this.query.page = parseInt(page);
      _this.listLoading = true;
      _this.loadList();
    },
    // 筛选
    querySelect() {
      const _this = this;
      _this.query.page = 1;
      _this.listLoading = true;
      _this.loadList();
    },
    finish() {
      const _this = this;
      _this.query.page = 1;
      _this.listLoading = true;
      _this.loadList();
    },
    finishNotFirst() {
      const _this = this;
      _this.listLoading = true;
      _this.loadList();
    }
  },
};
</script>

<style scoped>
.custom-tree-node {
  display: flex;
  justify-content: space-between;
}

.custom-tree-node-name {
  width: 400px;
}
</style>